export default __webpack_public_path__ + "static/lframe-home-reno-loan-684bdf3d7f4f8042451185e7255004c8.webp";